module.exports = __webpack_public_path__ + "static/media/hemp-leaves.2c66d56a.jpg";